import React, {Component}      from "react";
import {FontAwesomeIcon}       from "@fortawesome/react-fontawesome";
import {faUser}           from "@fortawesome/pro-solid-svg-icons";
import GenericModelButton from "app/main/genericComponents/buttons/modelButtons/GenericModelButton";

class CustomerButton extends Component {

    render() {

        return (<GenericModelButton
                {...this.props}
                url={"/clients/" + this.props.customer.customer_no}
                buttontext={this.props.customer.customer_no}
                capitalized={1}
                startIcon={<FontAwesomeIcon icon={faUser} className={"opacity-75 ml-4"}/>}
            />
        );
    }
}

export default (CustomerButton);
